export const PRICE_BREAKDOWN = "Price breakdown";
export const ROOM = "Room";
export const NIGHT = "night";
export const TAXES_AND_FEES = "Taxes & fees";
export const PAID_AT_TIME_OF_BOOKING = "Paid at time of booking";
export const CANCEL_FOR_ANY_REASON = "Cancel for any reason";
export const TRIP_TOTAL = "Total";
